import { takeLatest, put, call } from 'redux-saga/effects';

import { findPatrimonioAlertaManutencaoCadastro } from '../service';
import {
  FIND_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO,
  FIND_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO_PENDING,
  FIND_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO_SUCCESS,
  FIND_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaFindPatrimonioAlertaManutencaoCadastro(action) {
  yield put({ type: FIND_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO_PENDING, id: action.id })

  try {
    const registro = yield call(findPatrimonioAlertaManutencaoCadastro, action.id);

    yield put({ type: FIND_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO_SUCCESS, registro: registro })
  } catch (error) {
    yield put({ type: FIND_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line
  }
}

export default function* watchFindPatrimonioAlertaManutencaoCadastro() {
  yield takeLatest(FIND_PATRIMONIO_ALERTA_MANUTENCAO_CADASTRO, sagaFindPatrimonioAlertaManutencaoCadastro)
}
